import React from 'react';

export interface CasaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CasaIcon: React.FC<CasaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" clipPath="url(#a)"><path d="m3.16 23.617-.01-9.456-1.348-1.25L12.555 2.112 23.307 12.91l-1.348 1.251-.01 9.456z"/><path d="M14.795 23.619h-4.48V16.51a.45.45 0 0 1 .447-.45h3.585a.45.45 0 0 1 .448.45zM3.15 15.107l9.404-9.43 9.405 9.43"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.054.366h25v25h-25z"/></clipPath></defs>
    </svg>
  );
};

export default CasaIcon;
